module.exports = __webpack_public_path__ + "img/icon_shexiangtoulixian.c5e50a1b.png";